import type { Paths } from '@/types/schemas/agent-schema';
import type { CheckoutValues } from '@/utils/zodSchema';

export type UpdatePurchaserFormValues = Partial<CheckoutValues['purchaser']>;

export const buildUpdatePurchaserPayload = (
  values: UpdatePurchaserFormValues
): Paths.BookingsUpdatePurchaser.RequestBody => {
  const {
    externalReference,
    firstName,
    lastName,
    email,
    phoneNumber,
    streetName,
  } = values;

  return {
    externalReference,
    firstName,
    lastName,
    email,
    phoneNumber,
    ...(streetName ? { address: { streetName } } : {}),
  };
};
